export default __webpack_public_path__ + "static/media/text.319aaa78.png";